import { Trans, useTranslations } from "adapters/i18n";
import ConfirmationModal from "features/shared/components/confirmationModal";
import React from "react";

const ModalNoFarmOnClient = ({
  classes,
  setIsModalShown,
  clienteSelecionado,
}) => {
  const { t } = useTranslations();

  return (
    <ConfirmationModal
      classNames={{
        customClass: classes.customClass,
        submitButtonContainer: classes.submitButtonContainer,
      }}
      title={
        <span className={classes.modalTitle}>
          {t("errors:no-linked-farm.title")}
        </span>
      }
      text={
        <span className={classes.modalText}>
          <Trans
            i18nKey="errors:no-linked-farm.description-for-client"
            components={{
              highlight: <span className={classes.modalTextInfo} />,
              br: <br />,
            }}
            values={{ clientName: clienteSelecionado.Nome }}
          />
        </span>
      }
      submitButtonTitle={t("common:actions.close")}
      onSubmit={setIsModalShown}
      onClose={setIsModalShown}
    />
  );
};

export default ModalNoFarmOnClient;
